import type { DemoKey } from '../types';

export const tr: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matematik · İstatistik',
  'app.title': 'İstatistik',
  'panel.experiment': 'Sahne',
  'panel.params': 'Parametreler',

  'exp.survey-explorer.title': 'Anket gezgini',
  'exp.survey-explorer.desc': 'Bir sütun seç; demo uygun özeti seçer.',
  'exp.distribution-sculptor.title': 'Dağılım heykeltıraşı',
  'exp.distribution-sculptor.desc': 'Noktaları sürükle, istatistiklerin tepkisini gör.',
  'exp.two-variable-lab.title': 'İki değişkenli laboratuvar',
  'exp.two-variable-lab.desc': 'Dağılım, uyum ve nedensellik sorusu.',
  'exp.sampling-lab.title': 'Örnekleme laboratuvarı',
  'exp.sampling-lab.desc': 'Teknik ve boy örneklem ortalamasını nasıl kaydırır.',
  'exp.probability-diagrams.title': 'Olasılık şemaları',
  'exp.probability-diagrams.desc': 'Bileşik olaylar için Venn ve ağaç görünümleri.',

  'type.qualitative-nominal.label': 'Niteliksel · adsal',
  'type.qualitative-nominal.def': 'Doğal sırası olmayan kategoriler.',
  'type.qualitative-ordinal.label': 'Niteliksel · sıralı',
  'type.qualitative-ordinal.def': 'Anlamlı sıraya sahip kategoriler.',
  'type.qualitative-multi.label': 'Niteliksel · çok değerli',
  'type.qualitative-multi.def': 'Her gözlemde birden çok etiket olabilir.',
  'type.quantitative-discrete.label': 'Niceliksel · kesikli',
  'type.quantitative-discrete.def': 'Sabit adımlarla gelen sayılar.',
  'type.quantitative-continuous.label': 'Niceliksel · sürekli',
  'type.quantitative-continuous.def': 'Sürekli ölçekte ölçülen sayılar.',

  'column.name.label': 'Öğrenci adı',
  'column.height_cm.label': 'Boy',
  'column.shoe_size_eu.label': 'Ayakkabı numarası (EU)',
  'column.study_hours.label': 'Çalışma saati / hafta',
  'column.test_score.label': 'Sınav puanı',
  'column.sports_played.label': 'Oynanan sporlar',
  'column.eye_color.label': 'Göz rengi',
  'column.commute_min.label': 'Yol',
  'column.grade_year.label': 'Sınıf',
  'column.homework_effort.label': 'Ödev çabası',
  'column.ice-cream-sales.label': 'Dondurma satışı',
  'column.drownings.label': 'Boğulmalar',
  'column.month.label': 'Ay',
  'column.storks.label': 'Leylekler',
  'column.births.label': 'Doğumlar',
  'column.country_area_km2.label': 'Ülke alanı',
  'column.sleep_hours.label': 'Uyku saati',
  'column.reaction_ms.label': 'Tepki süresi',

  'dataset.master-survey.label': 'Sınıf anketi',
  'dataset.master-survey.desc': '30 simüle öğrenci.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Dondurma satışı vs boğulma',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Her ikisi de mevsimle iniş çıkış yapar. Boğulma dondurma satışına sebep olmaz.',
  'dataset.spurious-storks-vs-births.label': 'Leylek vs doğum',
  'dataset.spurious-storks-vs-births.desc':
    'Büyük ülkelerde daha çok leylek ve doğum var. Kuşlar sebep değil.',
  'dataset.real-sleep-vs-reaction-time.label': 'Uyku vs tepki süresi',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Daha çok uyku, daha hızlı tepki. Gerçek negatif korelasyon — makul bir mekanizmayla.',

  'tag.football.label': 'Futbol',
  'tag.basketball.label': 'Basketbol',
  'tag.volleyball.label': 'Voleybol',
  'tag.swimming.label': 'Yüzme',
  'tag.none.label': 'Hiçbiri',

  'population.gaussian.label': 'Çan eğrisi',
  'population.right-skewed.label': 'Sağa çarpık',
  'population.bimodal.label': 'Çift tepeli (katmanlı)',
  'population.uniform.label': 'Düzgün',

  'venn.dice-even-or-prime.label': 'Zar: çift veya asal',
  'venn.class-sports-2set.label': 'Spor (2 küme)',
  'venn.class-sports-3set.label': 'Spor (3 küme)',
  'venn.custom.label': 'Özel',

  'tree.draw-without-replacement.label': 'İadesiz çekiliş',
  'tree.custom.label': 'Özel',
  'tree.coin.heads': 'Y',
  'tree.coin.tails': 'T',
  'tree.draw.start': 'Torba: 2 kırmızı, 3 mavi',
  'tree.draw.red': 'Kırmızı',
  'tree.draw.blue': 'Mavi',
  'tree.custom.start': 'Başla',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogram',
  'card.cumulative': 'Kümülatif frekans',
  'card.box': 'Kutu grafiği',
  'card.summary': '5 sayı özeti',
  'card.bar': 'Çubuk grafik',
  'card.mode': 'Mod',
  'card.tag-frequency': 'Etiket frekansı',
  'card.mode-tag': 'En sık etiket',
  'card.empty-no-order': 'Uygulanamaz',
  'card.empty-multi': 'Uygulanamaz',
  'card.numberline': 'Sayı doğrusu',
  'card.scatter': 'Dağılım',
  'card.description': 'Ne oluyor',
  'card.population': 'Anakütle',
  'card.sampling-distribution': 'Örneklem ortalamaları',
  'card.venn': 'Venn',
  'card.tree': 'Ağaç',
  'card.probabilities': 'Olasılıklar',

  'param.dataset.label': 'Veri kümesi',
  'param.column.label': 'Sütun',
  'param.bins.label': 'Aralık',
  'param.shape.label': 'Başlangıç şekli',
  'param.show-mean.label': 'Ortalamayı göster',
  'param.show-median.label': 'Medyanı göster',
  'param.x-col.label': 'X sütunu',
  'param.y-col.label': 'Y sütunu',
  'param.show-regression.label': 'Regresyon doğrusu',
  'param.show-residuals.label': 'Artıklar',
  'param.show-confounder.label': 'Karıştırıcı göster',
  'param.population.label': 'Anakütle',
  'param.technique.label': 'Yöntem',
  'param.sample-size.label': 'Örneklem boyu',
  'param.stratum.label': 'Tabaka',
  'param.bias.label': 'Yanlılık',
  'param.mode.label': 'Mod',
  'param.preset.label': 'Hazır ayar',
  'param.universe.label': 'Evren boyu',
  'param.show-prob.label': 'Olasılıkları göster',
  'param.treat-as-numeric.label': 'Sayısal say',

  'stat.count': 'Adet',
  'stat.mean': 'Ortalama',
  'stat.median': 'Medyan',
  'stat.range': 'Açıklık',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Aykırı değerler',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'Eğim',
  'stat.intercept': 'Kesim noktası',
  'stat.n': 'n',
  'stat.population-mean': 'Gerçek ortalama',
  'stat.latest-sample-mean': 'Örneklem ortalaması',
  'stat.sample-mean-spread': 'Örneklem ort. SS',
  'stat.sample-count': 'Çekilen örneklem',
  'outlier.upper': 'Üst aykırılar',
  'outlier.lower': 'Alt aykırılar',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Yeniden örnekle',
  'btn.run-100': '100 örneklem çek',
  'btn.stop': 'Durdur',
  'btn.clear-history': 'Geçmişi temizle',

  'explainer.no-order': 'Sıra yok → kümülatif yok, kutu yok.',
  'explainer.multi-no-iqr': 'Çok değerli → çeyrek / IQR tanımsız.',
  'message.no-data': 'Veri yok.',
  'message.needs-quartiles': 'Çeyrekler için ≥4 nokta gerekir.',
  'message.x-zero-variance': 'X varyansı sıfır — uygun doğru yok.',
  'message.n-too-small': 'n çok küçük.',
  'message.stratum-clamp': 'Tabakada istenenden az satır vardı — tümü kullanıldı.',
  'message.siblings-sum-to-one': 'Kardeşler 1’e toplanmalı.',
};
